/** Номер счетчика Yandex метрики https://yandex.ru/support/metrica/objects/reachgoal.html */
export const MARKETING_YANDEX_ID = Number(process.env.GATSBY_YANDEX_METRIKA_COUNTER_ID) || 0;

/** Идентификатор счётчика веб-аналитики ostr.io https://ostr.io/info/web-analytics */
export const MARKETING_OSTRIO_ID = process.env.GATSBY_OSTRIO_TRACKING_ID || "";

/** Путь беакона ostr.io на бэке — `OstrioAnalytics.Endpoint` в конфиге foretellcore. */
const OSTRIO_BEACON_PATH = "/service/__a/";

/**
 * First-party база беакона ostr.io: туда трекер шлёт `{trackingId}.gif`, оттуда же
 * грузится сам скрипт трекера. Считается от `GATSBY_API_URL`, а не задаётся отдельно:
 * стенды переключают бэкенд через `choose_backend_api`, который правит только его.
 */
export const MARKETING_OSTRIO_BEACON_URL = process.env.GATSBY_API_URL
  ? new URL(OSTRIO_BEACON_PATH, process.env.GATSBY_API_URL).href
  : "";
